// extracted by css-extract-rspack-plugin
export default {"section":"Releases-module__section___T3eT","count":"Releases-module__count__Zz6ky"};